import React from 'react'
import PropTypes from 'prop-types'
import ReportsDropdown from 'components/K8ReportingLeaderTools/ReportsDropdown'
import CSVReportsDropdown from 'components/ReportsNavHeader/CSVReportsDropdown'
import { ExportButtonWrapper, StyledAdminTooltip } from './component.styles'

const AdminExportDownloadButton = ({
  className,
  historicalReports,
  historicalReportingOnClick,
  isFetching,
  onClickCurrentYear,
  programKey,
  tooltipLocation,
  buttonText,
  useLeaderToolsStyles,
}) => {
  const Dropdown = useLeaderToolsStyles ? ReportsDropdown : CSVReportsDropdown

  return (
    <ExportButtonWrapper className={className}>
      <Dropdown
        buttonText={buttonText}
        excludeLabels={true}
        historicalReportingOnClick={historicalReportingOnClick}
        historicalReports={historicalReports}
        isFetching={isFetching}
        onClickCurrentYear={onClickCurrentYear}
        showLoadingText={false}
      />
      <StyledAdminTooltip
        location={tooltipLocation}
        monitorView
        programKey={programKey}
      />
    </ExportButtonWrapper>
  )
}

AdminExportDownloadButton.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isFetching: PropTypes.bool,
  onClickCurrentYear: PropTypes.func,
  programKey: PropTypes.string,
  tooltipLocation: PropTypes.string,
  useLeaderToolsStyles: PropTypes.bool,
}

export default AdminExportDownloadButton
